import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetalen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Betalen_svg__a"
      width={32}
      height={16}
      x={4}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M36 12H4v16h32z"
      />
    </mask>
    <g mask="url(#Betalen_svg__a)">
      <path
        fill="#F18700"
        d="m8.57 45.53-12.24-7.08L3.4 26.21z"
      />
      <path
        fill="#F7A941"
        d="m22.72 21.03-12.25-7.07 7.07-12.25z"
      />
      <path
        fill="#F18700"
        d="m-1.78 6.89 12.25 7.07L3.4 26.21z"
      />
      <path
        fill="#F7A941"
        d="m3.4 26.21 7.07-12.25 12.25 7.07z"
      />
      <path
        fill="#F18700"
        d="m17.54 1.71-7.07 12.25-12.25-7.07z"
      />
      <path
        fill="#F7A941"
        d="M42.04 15.86 29.79 8.78l7.07-12.24z"
      />
      <path
        fill="#F18700"
        d="m17.54 1.71 12.25 7.07-7.07 12.25zM22.72 21.03l7.07-12.25 12.25 7.08zM22.72 21.03l12.25 7.07-7.08 12.25z"
      />
      <path
        fill="#F7A941"
        d="M47.21 35.17 34.97 28.1l7.07-12.24zM42.04 15.86 34.97 28.1l-12.25-7.07zM3.4 26.21l12.25 7.07-7.08 12.25z"
      />
      <path
        fill="#F18700"
        d="m27.89 40.35-12.24-7.07 7.07-12.25z"
      />
      <path
        fill="#F7A941"
        d="m22.72 21.03-7.07 12.25L3.4 26.21z"
      />
    </g>
    <path
      fill="#fff"
      d="M20 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetalen);

export default ForwardRef;
